import type {SelectOptionItem} from '@yandex-delivery/blocks'
import {
  allPass,
  applySpec,
  firstOf,
  flow,
  get,
  ifElse,
  join,
  toDefaultEmptyString,
  trim,
} from '@yandex-delivery/utils'
import type {PickupStation} from 'src/shared/types'

// @ts-expect-error TODO: Обновить типы API. Полей `street` и `house` нет в типе LocationDetails, хотя с бекенда они приходят
const isStreetAndHouseExist: (item: PickupStation['address']) => boolean =
  allPass([get('street'), get('house')])

const getStreetHouse: (item: PickupStation['address']) => string = flow(
  applySpec([get('street'), get('house')]),
  join(' '),
  trim,
)

const getFullAddress: (item: PickupStation) => string | undefined = flow(
  get('address'),
  ifElse(isStreetAndHouseExist, getStreetHouse, get('full_address')),
)

export const getFilterLabel: (item: PickupStation) => string = flow(
  applySpec([getFullAddress, get('name')]),
  join(' '),
  trim,
)

export const getLabel: (item: SelectOptionItem<PickupStation>) => string = flow(
  get('value'),
  firstOf(getFullAddress, get('name')),
  toDefaultEmptyString,
)

export function filter(textValue: string, inputValue: string) {
  return textValue.toLowerCase().includes(inputValue.toLowerCase())
}
